import React, { useEffect, useState } from "react";
import { get } from 'lodash';
import classNames from 'classnames';
class Collapsable extends React.Component {

  constructor(props) {

    super(props);

    const collapseTitle = get(props, 'attributes.collapseTitle', false);
    const collapseContent = get(props, 'attributes.collapseContent', false);

    this.state = {open: false,
      collapseTitle: collapseTitle,
      collapseContent: collapseContent
    };

  }

  render() {

    return (
      <div className={classNames({
        'collapse-wrap': true,
        'open': this.state.open == true,
        'closed': this.state.open == false
      })}>
        <h5 className="collapse-title" onClick={(e) => this.setState({open: !this.state.open})}> {this.state.collapseTitle}</h5>
        <div className="collapse-content-wrap">
            <div className="collapse-content" dangerouslySetInnerHTML={{__html: this.state.collapseContent}}></div>
          </div>
      </div>
    );
  }
}

export default Collapsable;
